export default "__VITE_ASSET__DDyvDz9s__"